import moment from "moment";

export const handleFormatDateToPhraseSignature = (date: string) => {
  return moment(date).format("DD [de] MMMM [de] YYYY");
};
